// (function () {
//     'use strict';
//
//     angular
//         .module('estadisticas')
//         .directive('graficosMenu', GraficosMenuDirective);


    GraficosMenuDirective.$inject = [];
     export default function GraficosMenuDirective() {
        return {
            restrict: 'E',
            scope: {},
            template: require('./graficos-menu.html'),
            controller: 'GraficosMenuCtrl',
            controllerAs: 'vm',
            bindToController: true
        }
    }

// })();